export enum MapListMode {
    Map = "map",
    List = "list"
}
